module.exports = __webpack_public_path__ + "img/youtube.fb08df07.svg";